import React from "react";
import { useParams } from "react-router-dom";
import { SpecialistData } from "./SpecialistData";
import {Box, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography} from "@mui/material";
import tick from "../../../assets/arrow_right red.png";

const SpecialistDetailPage = () => {
    const { id } = useParams();

    const specialist = SpecialistData.find(p => p.id.toString() === id);

    if (!specialist) {
        return <h2>Specialist not found</h2>;
    }

    return (
        <>
        <Box py={6} sx={{ background: 'linear-gradient(#E7F0FF, #E8F1FF)' }}>
            <Container>
                <Grid container spacing={6} alignItems='center'>

                    <Grid item xs={12} md={6}>
                        <Box
                            component='img'
                            src={specialist.img}
                            width={1}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography
                            fontWeight={600}
                            color="primary.main"
                        >
                        </Typography>
                        <Typography variant="h2" mb={1}>
                            {specialist.title}<Box component='span' color='primary.main'></Box>
                        </Typography>
                        <Typography color='#77829D' lineHeight={1.7} textAlign="justify"
                                    sx={{ textJustify: 'inter-word' }}>
                            {specialist.description}
                            <br/>
                        </Typography>
                        <List sx={{ fontSize: { xs: 12, md: 18 } }}>
                            <ListItem disableGutters>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                    <Box component='img' src={tick} height={22} width={22} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`Speciality : ${specialist.designation}`}
                                    primaryTypographyProps={{ fontSize: { xs: 14, md: 18 }, fontWeight: 500, color: '#262262' }}
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                    <Box component='img' src={tick} height={22} width={22} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`Degree : ${specialist.degree_detail}`}
                                    primaryTypographyProps={{ fontSize: { xs: 14, md: 18 }, fontWeight: 500, color: '#262262' }}
                                />
                            </ListItem>
                            <ListItem disableGutters>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                    <Box component='img' src={tick} height={22} width={22} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`Experience : ${specialist.experience}`}
                                    primaryTypographyProps={{ fontSize: { xs: 14, md: 18 }, fontWeight: 500, color: '#262262' }}
                                />
                            </ListItem>
                        </List>

                    </Grid>
                </Grid>
            </Container>
        </Box>
            {(specialist?.publication_content || specialist?.publications_img) && (
                <Box py={6} sx={{ background: '#FFFFFF' }}>
                    <Container>
                        <Grid container spacing={6} alignItems="center">
                            {specialist?.publication_content && (
                                <Grid item xs={12} md={specialist?.publications_img ? 6 : 12}>
                                    <Typography variant="h2" mb={1}>Publications :</Typography>
                                    <Typography color="#77829D" lineHeight={1.8}>
                                        {[
                                            specialist.publication_content,
                                            specialist.publication_content_1,
                                            specialist.publication_content_2,
                                            specialist.publication_content_3,
                                            specialist.publication_content_4]
                                            .filter(content => content) // Filters out empty/null values
                                            .map((content, index) => (
                                                <React.Fragment key={index}>
                                                    {content}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                    </Typography>
                                </Grid>
                            )}
                            {specialist?.publications_img && (
                                <Grid item xs={12} md={specialist?.publication_content ? 6 : 12}>
                                    <Box component="img" src={specialist.publications_img} width={1} />
                                </Grid>
                            )}
                        </Grid>
                    </Container>
                </Box>
            )}
            {(specialist?.certification_content || specialist?.certification_img) && (
                <Box py={6} sx={{ background: 'linear-gradient(#E7F0FF, #E8F1FF)' }}>
                    <Container>
                        <Grid container spacing={6} alignItems="center">
                            {specialist?.certification_img && (
                                <Grid item xs={12} md={6}>
                                    <Box
                                        component="img"
                                        src={specialist.certification_img}
                                        width={1}
                                    />
                                </Grid>
                            )}
                            {specialist?.certification_content && (
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h2" mb={1}>
                                        Certifications : <Box component="span" color="primary.main"></Box>
                                    </Typography>
                                    <List sx={{ fontSize: { xs: 12, md: 18 } }}>
                                        {[
                                            specialist.certification_content,
                                            specialist.certification_content_1,
                                            specialist.certification_content_2,
                                            specialist.certification_content_3,
                                        ]
                                            .filter(content => content)
                                            .map((content, index) => (
                                                <ListItem disableGutters key={index}>
                                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                                        <Box component="img" src={tick} height={22} width={22} />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={content}
                                                        primaryTypographyProps={{
                                                            fontSize: { xs: 14, md: 18 },
                                                            fontWeight: 500,
                                                            color: "#262262"
                                                        }}
                                                    />
                                                </ListItem>
                                            ))}
                                    </List>
                                </Grid>
                            )}
                        </Grid>
                    </Container>
                </Box>
            )}

        </>
    );
};

export default SpecialistDetailPage;
